import { render, staticRenderFns } from "./Catposts.vue?vue&type=template&id=5cadfa45&"
import script from "./Catposts.vue?vue&type=script&lang=js&"
export * from "./Catposts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports